module.exports = __webpack_public_path__ + "c17ca80be0b73f7aaf406ec9b3ec7f81.jpg";